import styled from "styled-components";
import { xlg, sm, ssm } from "../../../AppTheme.styled";

const StyledContainer = styled.div<{
  small?: boolean;
  margin?: number;
  vertical?: boolean;
  padding?: string;
  fullWidth?: boolean;
  textAlign?: string;
  centered?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 0 15px 40px;
  height: 100%;
  min-height: 100vh;

  .pageContent {
    flex-grow: 1;
  }

  ${ssm} {
    padding: 0 32px;
  }

  ${sm} {
    padding: 0 32px 32px;
  }

  ${xlg} {
    padding: 0 40px 40px;
  }
`;

export default StyledContainer;
